export const USER_ARTICLE_VIEWED_EVENT = "user_article_viewed";
